import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=46e90ce6&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"
import style0 from "./Plans.vue?vue&type=style&index=0&id=46e90ce6&prod&lang=scss&scoped=true"
import style1 from "./Plans.vue?vue&type=style&index=1&id=46e90ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e90ce6",
  null
  
)

export default component.exports